var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"test",attrs:{"id":"app "}},[_c('FadeTransition',{attrs:{"duration":400,"mode":"out-in"}},[_c('router-view',{staticClass:"routercontent",staticStyle:{"width":"100vw","overflow-x":"hidden"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }